<div class="modal-header" ngbAutofocus>
  <h6 class="modal-title">รายการดึงข้อมูล — Token: {{ token }}</h6>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.close()"></button>
</div>
<div class="modal-body">
  @if (loading()) {
    <div class="text-center py-4 text-body-secondary">กำลังโหลด...</div>
  } @else if (items().length === 0) {
    <div class="text-center py-4 text-body-secondary">- ไม่มีข้อมูล -</div>
  } @else {
    <div class="table-responsive border" style="max-height: 400px; overflow-y: auto;">
      <table class="table table-sm mb-0">
        <thead class="bg-light sticky-top">
          <tr>
            <th>#</th>
            <th>ThaitracesID</th>
            <th>ReqID</th>
            <th>รูปแบบ</th>
            <th>Error</th>
          </tr>
        </thead>
        <tbody>
          @for (item of items(); track item.thaiTracesFormId; let i = $index) {
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ item.thaiTracesFormId || '-' }}</td>
              <td>{{ item.rosRformReqId || '-' }}</td>
              <td>{{ item.type || '-' }}</td>
              <td>
                @if (item.errorJson) {
                  <pre style="word-wrap: break-word; white-space: pre-wrap; margin: 0; font-size: 11px;">{{ formatJson(item.errorJson) }}</pre>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="modal.close()">ปิด</button>
</div>
